import { HttpClient } from './HttpClient.js';

export const ProjectTraking = {
    async getProjectTraking(form) {
        return await HttpClient.get('/follow-up/get-managements/'+form).then(response => response);
    },

    async reporte(form){
        return await HttpClient.post('/follow-up/export-xlsx',form).then(response => response);
    },

    async getProjectTrakingPerDates(dateStart, dateEnd){
        return await HttpClient.get('/follow-up/get-managements-by-range/'+dateStart+'/'+dateEnd)
        .then(response => response);
    }
}